import React from 'react';
import Select from 'react-select';
import { toAbsoluteUrl } from "../../../../_metronic";

export default function SelectLanguage(props) {
    const options = [
        { 
            value: 'pt-BR', 
            label: <div><img src={toAbsoluteUrl("/media/flags/255-brazil.svg")} alt="" width="20px" height="20px" /> Português </div> 
        },
        { 
            value: 'en-US', 
            label: <div><img src={toAbsoluteUrl("/media/flags/226-united-states.svg")} alt="" width="20px" height="20px" /> English </div> 
        }
    ];

    return <Select 
                options={options} 
                onChange={props.handleChangeLanguage} 
                placeholder={props.translate.defaultMessages?.selectLanguage}
                value={options.filter(option => option.value === props.languageValue)}
            />
}